// Limits on the photos staff attach to a new outbound ticket email.
// One definition for the popup (refuses at pick time) and prism-api (refuses
// before anything is stored or sent).

export const MAX_OUTBOUND_FILES = 5;

// The Gmail sender holds about 14 MB of memory per MB of attachment, and a
// Worker has 128 MB. Measured 2026-10-09: 7 MB of photos peaked at 98 MB,
// 10 MB at 138 MB. The popup shrinks photos first, so 5 photos fit easily.
const MAX_OUTBOUND_TOTAL_MB = 6;
export const MAX_OUTBOUND_TOTAL_BYTES = MAX_OUTBOUND_TOTAL_MB * 1024 * 1024;

export const OUTBOUND_LIMIT_HINT = `Up to ${MAX_OUTBOUND_FILES} photos, ${MAX_OUTBOUND_TOTAL_MB} MB combined`;

/** Returns why this set of files ({ size }) is refused, or null when it fits. */
export function outboundAttachmentLimitError(files) {
    if (files.length > MAX_OUTBOUND_FILES) {
        return `Too many attachments. The limit is ${MAX_OUTBOUND_FILES} files.`;
    }
    const totalBytes = files.reduce((sum, file) => sum + file.size, 0);
    if (totalBytes > MAX_OUTBOUND_TOTAL_BYTES) {
        return `Attachments are too large. The limit is ${MAX_OUTBOUND_TOTAL_MB} MB combined.`;
    }
    return null;
}
